<template>
  <!-- editAgency Modal -->
  <div
    class="modal fade"
    id="editAgencyModal"
    tabindex="-1"
    aria-labelledby="editAgencyModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="editAgencyModalLabel">
            Edit Agency Details
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="cancel"
          ></button>
        </div>
        <form @submit.prevent>
        <div class="modal-body">
          <div class="mb-3">
            <label for="agencyId" class="form-label">Agency ID<span style="color: red;"> *</span></label>
            <input
              type="text"
              class="form-control"
              id="agencyId"
              v-model="agencyId"
              disabled
              readonly
              required
            /> 
          </div>
          <div class="mb-3">
            <label for="agencyName" class="form-label">Agency Name<span style="color: red;"> *</span></label>
            <input
             v-if="agencyStore.currentAgency.active == true"
              type="text"
              class="form-control"
              id="agencyName"
              v-model="agencyName"
              required
            />
            <input
            v-else
              type="text"
              class="form-control"
              id="agencyName"
              v-model="agencyName"
              readonly
              disabled
              required
            />
          </div>
          <div class="mb-3">
            <label for="agencySftpUsername" class="form-label">Agency SFTP Username<span style="color: red;"> *</span></label>
            <input
            v-if="agencyStore.currentAgency.active == true"
              type="text"
              class="form-control"
              id="agencySftpUsername"
              v-model="agencySftpUsername"
              onkeypress="return event.charCode != 32"
              @focus="touched = true"
              required
            />
            <input
            v-else
              type="text"
              class="form-control"
              id="agencySftpUsername"
              v-model="agencySftpUsername"
              onkeypress="return event.charCode != 32"
              @focus="touched = true"
              required
              readonly
              disabled
            />
            <small v-if="touched && !isValid" class="text-danger">Input should contain characters without blank spaces.</small>
          </div>
        <div v-if="agencyStore.currentAgency.isProxy == false" >
          <div class="mb-3" >
            <label for="proxyId" class="form-label">Proxy ID</label>
            <select id="proxyId" class="form-select" v-model="proxyId" v-if="agencyStore.currentAgency.active == true">
              <option value="default">No Proxy Selected</option>
              <option v-for="item in agencyList">{{ item.proxyId }}</option>
            </select>
            <select id="proxyId" class="form-select" v-model="proxyId" v-else readonly disabled>
              <option value="default">No Proxy Selected</option>
              <option v-for="item in agencyList">{{ item.proxyId }}</option>
            </select>
          </div>
          <div class="mb-3">
            <label for="proxyName" class="form-label">Proxy Name</label>
            <input
              type="text"
              class="form-control"
              id="proxyName"
              v-model="proxyName"
              disabled
              readonly
            />
          </div>
        </div>
        <div class="mb-3" >
            <label for="active" class="form-label">Active/Inactive<span style="color: red;"> *</span></label>
            <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="agencyStatus"
                    id="agencyStatus"
                    value=true
                    v-model="agencyStatus"
                    :checked="agencyStore.currentAgency.active == true "
                  />
                  <label class="form-check-label" for="active"> Active </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="agencyStatus"
                    id="agencyStatus"
                    value=false
                    v-model="agencyStatus"
                    :checked="agencyStore.currentAgency.active == false "
                  />
                  <label class="form-check-label" for="Inactive">
                    Inactive
                  </label>
                </div>
          </div>
        


        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="cancel"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-success"
            style="width: 48.5%"
            :data-bs-dismiss=dismissModal()
            @click="submit"
          >
            Confirm
          </button>
        </div>
      </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useAgencyStore } from "@/stores/agency";

const agencyStore = useAgencyStore();
const agencyList = ref();
const agencyId = ref('');
const agencyName = ref('');
const agencySftpUsername = ref('');
const proxyId = ref('default');
const proxyName = ref(null);
const agencyUuid: any = ref();
const agencyStatus = ref('');
// to get  dropdwown list
watch(
  () => agencyStore.afterProcessAgency,
  () => {
    agencyStore.fetchProxyAgencyEditVersion(agencyStore.currentAgency.id);
    agencyList.value = agencyStore.proxyAgencyEdit;

  }
)

// match row user ID with dropdownlist
//contorl the name (when user select proxy id the name will auto fill)
watch(
  () => proxyId.value,
  (proxyId) => {
    proxyName.value = null; // Reset foundValue
   
    if(agencyList.value != null) {
      for (const obj of agencyList.value) {
        if (obj.proxyId === proxyId) {
          proxyName.value = obj.proxyName;
          break;
        }else{
          obj.proxyId == "default";
          proxyName.value= null;
        }
      }
     }
  }
)

const currentAgency = ref("");
const storeAgencyId = ref('');
const storeAgencyName = ref('');
const storeAgencySftpUsername = ref('');
const storeProxyId = ref('default');
const storeProxyName = ref(null);
const storeAgencyUuid: any = ref();
const storeAgencyStatus = ref('');


watch(
  () => agencyStore.currentAgency,
  (update) => {
    proxyId.value = 'default';
    currentAgency.value = update;
    agencyId.value = update.id;
    agencyName.value = update.name;
    agencySftpUsername.value = update.sftpUsername;
    agencyUuid.value = update.uuid;
    agencyStatus.value = update.active;
    storeAgencyId.value = update.id;
    storeAgencyName.value = update.name;
    storeAgencySftpUsername.value = update.sftpUsername;
    storeAgencyUuid.value = update.uuid;
    storeAgencyStatus.value = update.active;
     if(update.proxyId != null){
      proxyId.value = update.proxyId;
      proxyName.value = update.proxyName;
      storeProxyId.value = update.proxyId;
      storeProxyName.value = update.proxyName;
     } else {
      storeProxyId.value = 'default';
      storeProxyName.value = null;
     }
  },
)

watch(() => agencyStore.closeEditErrorModal, (close) => {
  if (close) {
    agencyName.value = storeAgencyName.value;
    agencySftpUsername.value = storeAgencySftpUsername.value;
    proxyId.value = storeProxyId.value;
    proxyName.value = storeProxyName.value;
    agencyStatus.value = storeAgencyStatus.value;
  }
});


const cancel = () => {
  
  agencyName.value = storeAgencyName.value;
  agencySftpUsername.value = storeAgencySftpUsername.value;
  proxyId.value = storeProxyId.value;
  proxyName.value = storeProxyName.value;
  agencyStatus.value = storeAgencyStatus.value;
  agencyStore.closeEditModal();
}

const trimUsername = ref("")
const isValid = ref(true);
const touched = ref(false);

const dismissModal = () => {
  trimUsername.value = agencySftpUsername.value.trim();
  if (!(agencyId.value == '' || agencyName.value == '' || trimUsername.value == '')) {
    agencyStore.closeEditModal();
    return "modal"
  }
};

const submit = async () => {
  trimUsername.value = agencySftpUsername.value.trim();
  isValid.value = !/^\s*$/.test(trimUsername.value);
  if (!(agencyId.value == '' || agencyName.value == '' || trimUsername.value == '')) {
    let status = true as boolean;
      if(agencyStatus.value == "true"){
        status = true ;
      }else if( agencyStatus.value == "false"){
        status = false ;
      }
    if(proxyId.value == 'default'){
      let editAgency = {
        active: status,
        name: agencyName.value,
        sftpUsername: agencySftpUsername.value,
      }

      await agencyStore.updateAgency(agencyUuid.value,editAgency);
    } else {
      let editAgency = {
        active: status,
        name: agencyName.value,
        sftpUsername: agencySftpUsername.value,
        proxyId: proxyId.value,
        proxyName: proxyName.value,

      }
      await agencyStore.updateAgency(agencyUuid.value,editAgency);
    }
  }
  
  // agencyName.value = '';
  // agencySftpUsername.value = '';
  // proxyId.value = 'default';
  // proxyName.value = null;
};
</script>

<style scoped>
li {
  padding-right: 10px;
  margin: auto;
  display: inline-block;
}
</style>
